export default __webpack_public_path__ + "static/media/search.9940d2f9.png";